// src/components/ui/StatDisplay.tsx
import React from 'react';
// Adjust import path if StatItem is moved to a shared types file
import { StatItem } from '../Dashboard';
import { ArrowUp, ArrowDown } from 'lucide-react'; // Icons for change indicator

interface StatDisplayProps {
  stat: StatItem;
}

const StatDisplay: React.FC<StatDisplayProps> = ({ stat }) => {
  // Determine if change is positive, negative, or zero/invalid
  const changeValue = parseFloat(stat.change);
  const isPositive = !isNaN(changeValue) && changeValue > 0;
  const isNegative = !isNaN(changeValue) && changeValue < 0;

  // Format the change number part (add '+' if positive)
  const formattedChangeNumber = isPositive ? `+${stat.change}` : stat.change;
  // Combine with prefix and suffix
  const formattedChange = `${stat.change_prefix || ''}${formattedChangeNumber}${stat.change_suffix || ''}`;

  // Format the main number with prefix and suffix
  const formattedNumber = `${stat.prefix || ''}${stat.number}${stat.suffix || ''}`;

  return (
    // --- Updated Layout: Vertical Stack --- 
    <div className="flex flex-col items-start" title={stat.title}>

      <span className="text-xs text-theme font-bold uppercase mb-1 truncate min-w-[100px] max-w-[130px]">{stat.title}</span>
      <div className="flex rounded-full bg-theme  px-2 py-1 items-baseline gap-1">
         {/* Main Number (with prefix/suffix) */} 
         <span className="font-semibold text-sm text-theme">{formattedNumber}</span>

         {/* Change Indicator with Hover Tooltip */}
         {(!isNaN(changeValue) && changeValue !== 0) && (
           <span 
             className={`flex items-center text-xs font-medium ${isPositive ? 'text-green-500' : 'text-red-500'} group relative`}
           >
             {isPositive && <ArrowUp className="h-2.5 w-2.5 mr-0.5" />} 
             {isNegative && <ArrowDown className="h-2.5 w-2.5 mr-0.5" />} 
  
             {/* Hover Tooltip */}
             <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-gray-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
               {formattedChange}
             </span>
           </span>
         )}
      </div>
    </div>
  );
};

export default StatDisplay;